import { Component, ViewChild } from '@angular/core';
import { ColDef } from 'ag-grid-enterprise';
import { StudentMigrationService } from '../student-migration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastmessageService } from 'src/app/toastmessage.service';

@Component({
  selector: 'app-migration-entry',
  templateUrl: './migration-entry.component.html',
  styleUrls: ['./migration-entry.component.scss']
})
export class MigrationEntryComponent {
  searchCriteria: any;
  searchCriteria1: any;
  sai: any
  searchdata: any;
  concession: any;
  resentsearchlist: any;
  rowData: any[] = [];
  pinnedTopRowData: any[] = [];
  courseTrack: any;
  studentuniqueId: any;
  searchkey: any;
  name: any;
  parentname: any;
  // show=1;
  show: number = 1
  saveadmNo: { "searchKey ": any; "searchSelected ": any; "searchType ": string; "favourite ": string; businessType: string; "parentName ": any; };
  businessType: any = "COLLEGE"
  favourite: boolean = false
  searchType: any = "STUDENT"
  foundStudent: any;
  admission: any;
  searchdata2: any;
  uniqueRefrenceId: any;
  organizationnames: any
  admno: any;
  studentType: any;
  status: any;
  campusName: any;
  selected: string;
  migrationForm!: FormGroup;
  orgId: any;
  academicYear: any;
  listdata: any;
  data: any;
    @ViewChild('inputField1') inputField1: any;
    @ViewChild('inputField') inputField: any;
    

  constructor(private student: StudentMigrationService,  private spinner: NgxSpinnerService, private fb: FormBuilder, private toast:ToastmessageService) {
    this.migrationForm = this.fb.group({
      organizationId: ["", Validators.required],
      academicYear: ["beforecurrentyear", Validators.required],

    })
  }
  ngOnInit(): void {
 
    this.orgnazationlist()
  }
  onKeydown(event: any) {

    if (event.key === "Enter") {
      this.search()
    }
  }
  orgnazationlist() {
    this.student.orgnation().subscribe(res => {
      this.organizationnames = res
    })
  }
  applyFilter(e: any) {

  }
  onScroll(e: any) {

  }
  studentsearch(student: any) {
    this.spinner.show()
    console.log("student", student);
    this.uniqueRefrenceId = student.uniqueRefId
    this.admission = student.searchSelected
    let payload = {
      "stdName": "",
      "admNo": "",
      "parentName": "",
      "mobileNo": 0,
      "pageCount": 1,
      "searchKey": student.searchSelected ? student.searchSelected : "",
      "businessType": "COLLEGE"
    };


    this.student.Search(payload).subscribe(
      (res: any) => {
        this.searchdata2 = res;
        this.findStudentBySearchKey(student.searchSelected);
       
        this.spinner.hide();
      },
      (error: any) => {
        console.error("API Error:", error);
        this.spinner.hide();
      }
    );


    this.show = 2
  }
  findStudentBySearchKey(searchKey: string) {
    this.foundStudent = this.searchdata2.find((student: any) => student.admNo === this.admission) || null;
    this.studentuniqueId = this.foundStudent.stdUniqueRefId ? this.foundStudent.stdUniqueRefId : this.foundStudent.uniqueRefId;
    this.courseTrack = this.foundStudent.courseTrackName ? this.foundStudent.courseTrackName : '';
    this.searchkey = this.foundStudent.admNo ? this.foundStudent.admNo : this.foundStudent.searchSelected;
    this.name = this.foundStudent.name ? this.foundStudent.name : this.foundStudent.searchName;
    this.parentname = this.foundStudent.parentName ? this.foundStudent.parentName : this.foundStudent.parentName;


    localStorage.setItem('studentuniqueId', this.studentuniqueId);


  }
  resentsearch() {
    // this.student.Resentsearch().subscribe((res: any) => {
    //   this.resentsearchlist = res;

    //   this.rowData = res;
    //   this.resentsearchlist = res;

    //   this.admNo = res.map((student: any) => student.searchSelected);
    //   this.admNo.forEach((admissionNumber: string) => {
    //     this.student.getimage(admissionNumber).subscribe((imageRes) => {
    //       console.log("Image for", admissionNumber, ":", imageRes);
    //     });
    //   });
    // });
  }
  filterSearchData() {

  }
  search() {
    console.log(this.searchCriteria);
    if (!this.searchCriteria?.trim()) {
      return; // Ignore empty search
    }
    let payload = {
      "stdName": "",
      "admNo": "",
      "parentName": "",
      "mobileNo": 0,
      "pageCount": 1,
      "searchKey": this.searchCriteria ? this.searchCriteria : "",
      "businessType": "COLLEGE"
    };

    this.callSearchAPI(payload);
  }
  callSearchAPI(payload: any) {
    this.spinner.show();
    this.searchdata = [];
    this.concession = [];

    this.student.Search(payload).subscribe(
      (res: any) => {
        this.searchdata = res;

        this.spinner.hide();
      },
      (error: any) => {
        console.error("API Error:", error);
        this.spinner.hide();
      }
    );
  }


  selectItem(item: any) {
    console.log("list", item);
    this.listdata = item
    this.studentuniqueId = item.stdUniqueRefId ? item.stdUniqueRefId : item.uniqueRefId;
    this.courseTrack = item.courseTrackName ? item.courseTrackName : '';
    this.searchkey = item.admNo ? item.admNo : item.searchSelected;
    this.name = item.name ? item.name : item.searchName;
    this.parentname = item.parentName ? item.parentName : item.parentName;
    this.admno = item.admno
    this.studentType = item.studentType
    this.status = item.status
    this.campusName = item.campusName
    this.searchCriteria=item.admNo ? item.admNo : item.searchSelected;+

    localStorage.setItem('studentuniqueId', this.studentuniqueId);


    // this.savestudent();
    this.searchdata = [];
  }



  // savestudent() {
  //   this.saveadmNo = {
  //     "searchKey ": this.searchkey,
  //     "searchSelected ": this.name,
  //     "searchType ": "STUDENT",
  //     "favourite ": "flase",
  //     "businessType": "COLLEGE",
  //     "parentName ": this.parentname
  //   }
  //   this.student.savestudentdata(this.searchkey, this.name, this.searchType, this.favourite, this.businessType, this.parentname)
  //     .subscribe((res: any) => {
  //       console.log("API Response:", res);
  //     }, (error: any) => {
  //       console.error("API Error:", error);
  //     });
  // }

  savestudent() {
    if (!this.migrationForm.value.organizationId ) {
      alert("Please Selected the  organization Name.");
      setTimeout(() => {
        this.inputField1?.nativeElement.focus();
      });
      // this.inputField1.nativeElement.focus();
      return;
    }
    if (!this.migrationForm.value.academicYear ) {
      alert("Please Selected the academicYear.");
      this.inputField.nativeElement.focus();
      return;
    }
    this.academicYear = this.migrationForm.value.academicYear;
    if (this.academicYear === "currentyear") {
      this.spinner.show()
      this.orgId = this.migrationForm.value.organizationId
      this.student.afferstudent(this.searchkey, this.orgId).subscribe(res => {
        this.data=res
        this.spinner.hide()
        if (Array.isArray(res) && res.length === 0) {
          this.toast.showSuccess(`Admission No ${this.searchkey} migrated successfully.`);
        } else {
          this.toast.showError(`Entity Change of this admNO ( ${this.searchkey})is failed `);
        }
      })
    } else if (this.academicYear === "beforecurrentyear") {
      this.spinner.show()
      this.orgId = this.migrationForm.value.organizationId
      console.log("orgId", this.orgId);

      this.student.beforestudent(this.searchkey, this.orgId).subscribe(res => {
        this.data=res
        this.spinner.hide();
        if (Array.isArray(res) && res.length === 0) {
          this.toast.showSuccess(`Admission No ${this.searchkey} migrated successfully.`);
        } else {
          this.toast.showError(`Entity Change of this admNO ( ${this.searchkey})is failed `);
        }
      })
    }
  }

}
